// This is a hard coded value based on the category "Expired" in the WordPress database
// TODO: in the future, consider a one-time script that runs on launch,
// querying for the categories and finding the expired one's ID.
export const CATEGORY_EXPIRED_INT = 80;
// The base64 encoded version of the above.
export const CATEGORY_EXPIRED_BASE64 = "dGVybTo4MA==";

export const COURSE_CATALOG_VARIABLES = {
  displayInCatalog: true,
  expiredCategories: [CATEGORY_EXPIRED_INT],
};
